<template>
  <div>
    <div class="table-box">
      <div class="right-title">工商信息</div>
      <table border="1" style="border-collapse: collapse; width: 100%">
        <tr>
          <th class="table-title">社会统一信用代码</th>
          <th colspan="2">{{ form.socialCode }}</th>
          <th class="table-title">企业名称</th>
          <th colspan="2">{{ form.firmName }}</th>
        </tr>
        <tr>
          <td rowspan="2" class="table-title">法定代表人</td>
          <td rowspan="2">{{ form.taxNo }}</td>
          <td class="table-title">登记状态</td>
          <td>{{ form.registerStatus }}</td>
          <td class="table-title">成立日期</td>
          <td>{{ form.buildingTime }}</td>
        </tr>
        <tr>
          <td class="table-title">注册资本</td>
          <td>{{ form.registerCapital }}</td>
          <td class="table-title">实缴资本</td>
          <td>{{ form.payCapital }}</td>
        </tr>
        <tr>
          <td class="table-title">组织机构代码</td>
          <td>{{ form.organizationCode }}</td>
          <td class="table-title">工商注册号</td>
          <td>{{ form.taxCertificate }}</td>
          <td class="table-title">纳税人识别号</td>
          <td>{{ form.taxNo }}</td>
        </tr>
        <tr>
          <td class="table-title">企业类型</td>
          <td>{{ form.firmType }}</td>
          <td class="table-title">经营期限</td>
          <td>{{ form.businessYears }}</td>
          <td class="table-title">纳税人资质</td>
          <td>{{ form.taxCredit }}</td>
        </tr>
        <tr>
          <td class="table-title">所属行业</td>
          <td>{{ form.industryType }}</td>
          <td class="table-title">所属地区</td>
          <td>{{ form.firmArea }}</td>
          <td class="table-title">登记机关</td>
          <td>{{ form.authority }}</td>
        </tr>
        <tr>
          <td class="table-title">人员规模</td>
          <td>{{ form.employeeNo }}</td>
          <td class="table-title">参保人数</td>
          <td>{{ form.contributorsIn }}</td>
          <td class="table-title">核准日期</td>
          <td>{{ form.dateApproval }}</td>
        </tr>
        <tr>
          <td class="table-title">英文名</td>
          <td colspan="2">{{ form.englishName }}</td>
          <td class="table-title">进出口企业代码</td>
          <td colspan="2">{{ form.taxNo }}</td>
        </tr>
        <tr>
          <td class="table-title">注册地址</td>
          <td colspan="5">{{ form.address }}</td>
        </tr>
        <tr>
          <td class="table-title">经营范围</td>
          <td colspan="5">{{ form.businessCondition }}</td>
        </tr>
      </table>
    </div>
    <div  style="margin-top:0.1rem;display:flex;">
     <div class="table-box" style="width:55%;">
        <div class="right-title">资质信息</div>
      <table border="1" style="border-collapse: collapse; width: 100%">
        <tr>
          <th>资质许可</th>
          <th>{{ form.trandMark }}</th>
        </tr>
        <tr>
          <th>知识产权</th>
          <th>{{ form.knowledgePoint }}</th>
        </tr>
        <tr>
          <th>商标信息</th>
          <th>{{ form.patent }}</th>
        </tr>
        <tr>
          <th>处罚规则</th>
          <th colspan="2">{{ form.punishmentRules }}</th>
        </tr>
      </table>
     </div>
      <div class="table-box" style="width:45%;margin-left:0.1rem; ">
         <div class="right-title">招聘信息</div>
         <div class="recruit">
            <div class="msg-item" v-for="item in tableData" :key="item.id">
                <div class="left">
                    <div class="company-name">{{ item.position }}</div>
                    <div class="type">
                        <div class="type-item">{{ item.expirence }}</div>
                    </div>
                </div>
                <div class="right">
                     <div class="name">{{ item.linkman }}</div>
                     <div class="job">{{ item.linkmanPositon }}</div>
                      <div class="job">{{ item.telephone }}</div>
                </div>
            </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";
export default {
  props: {
    form: Object
  },
  data(){
    return {
      tableData: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      api.getRecruitList({
        firmId: this.form.id
      }).then(res => {
        this.tableData = res.rows;
      })
    }
  }
};
</script>

<style scoped lang="scss">
table {
  margin: 0.1rem 0;
  th,
  td {
    padding: 0.05rem;
    text-align: center;
    color: #fff;
    border-color: rgba(39, 245, 255, 0.5);
  }

  .table-title {
    background: rgba(39, 245, 255, 0.05);
    min-width: 1rem;
  }
  
}
  .right-title {
    border-left: 2px solid #01c5f3;
    padding: 0 0.1rem;
    font-size: 0.12rem;
    font-weight: 550;
  }
.table-box {
    border: 1px solid #01c5f3;
    padding: 0.05rem;
    .msg-item{
        display: flex;
        align-items: center;
        font-size: 0.1rem;
        color: #fff;
        border: 1px solid #01c5f3;
        padding: 0.1rem;
        margin: 0.1rem;
        .left{
            width: 80%;
            .company-name{
                font-weight: 600;
                color: #01c5f3;
                font-size: 0.11rem;
                padding: 0.05rem 0;
            }
            .type{
                display: flex;
                align-items: center;
                .type-item{
                    background:#ddd ;
                    color: #9D9D9D;
                    border-radius: 0.2rem;
                    font-size: 0.05rem;
                    padding: 0.02rem;
                    margin: 0 0.02rem;
                }
            }
            .msg-footer{
                display: flex;
                align-items: center;
                font-size: 0.05rem;
                margin: .1rem 0;
                .company{
                    display: flex;
                    align-items: center;
                }
                .company-type{
                    margin-left: 0.1rem;
                }
                .tips{
                     margin-left: 0.1rem;
                }
                .num{
                     margin-left: 0.1rem;
                }
            }
        }
        .right{
            width: 20%;
            display: flex;
            flex-flow: column;
            align-items: center;
        }
    }
  }
.recruit{
  height: 1.14rem;
  overflow: hidden;
  overflow-y: auto;
}
</style>
